import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { SORT_ROWS } from "../../../../utils/candidatesV2Constants";
import { calcPos } from "../constants";

const DEFAULT_FIELD = "created_at";
const DEFAULT_DIR = "desc";

export const sortOptionValue = (opt) => (opt.sort_hiring_stage_id ? `${opt.key}:${opt.sort_hiring_stage_id}` : opt.key);

// Header "Sort" button + portal popover. Changes are staged and only applied on "Apply sort".
const SortDropdown = ({ sortField, sortDirection, sortOptions, onApply, disabled }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const [pendingField, setPendingField] = useState(sortField);
  const [pendingDir, setPendingDir] = useState(sortDirection);
  const btnWrapRef = useRef(null);
  const portalRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (
        btnWrapRef.current && !btnWrapRef.current.contains(e.target) &&
        (!portalRef.current || !portalRef.current.contains(e.target))
      ) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (open) {
      setPendingField(sortField);
      setPendingDir(sortDirection);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const toggle = () => {
    if (!open && btnWrapRef.current) setPos(calcPos(btnWrapRef.current, 6, 260));
    setOpen((s) => !s);
  };

  return (
    <>
      <div ref={btnWrapRef}>
        <button className="header-action-btn-v2" disabled={disabled} onClick={toggle}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" />
          </svg>
          Sort
        </button>
      </div>
      {open && pos && createPortal(
        <div className="sort-dropdown-v2" ref={portalRef}
          style={{ position: "fixed", top: pos.top, left: pos.left, zIndex: 9999 }}>
          <div className="sort-dropdown-head-v2">
            <span className="sort-dropdown-title-v2">SORT</span>
            <button type="button" className="sort-reset-btn-v2" onClick={() => { setPendingField(DEFAULT_FIELD); setPendingDir(DEFAULT_DIR); }}>Reset</button>
          </div>
          <div className="sort-section-v2">
            <span className="sort-section-label-v2">SORT BY</span>
            <select className="sort-select-v2" value={pendingField} onChange={(e) => setPendingField(e.target.value)}>
              {sortOptions.length > 0
                ? sortOptions.map((opt) => {
                    const val = sortOptionValue(opt);
                    return <option key={val} value={val}>{opt.label}</option>;
                  })
                : SORT_ROWS.map((row) => (
                    <option key={row.field} value={row.field}>{row.label}</option>
                  ))
              }
            </select>
          </div>
          <div className="sort-section-v2">
            <span className="sort-section-label-v2">DIRECTION</span>
            <div className="sort-dir-btns-v2">
              <button type="button" className={`sort-dir-btn-v2${pendingDir === "desc" ? " active" : ""}`} onClick={() => setPendingDir("desc")}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="6" x2="15" y2="6"/><line x1="3" y1="12" x2="11" y2="12"/><line x1="3" y1="18" x2="7" y2="18"/>
                  <polyline points="18 9 21 12 18 15"/>
                </svg>
                Descending
              </button>
              <button type="button" className={`sort-dir-btn-v2${pendingDir === "asc" ? " active" : ""}`} onClick={() => setPendingDir("asc")}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="6" x2="7" y2="6"/><line x1="3" y1="12" x2="11" y2="12"/><line x1="3" y1="18" x2="15" y2="18"/>
                  <polyline points="18 15 21 12 18 9"/>
                </svg>
                Ascending
              </button>
            </div>
          </div>
          <button type="button" className="sort-apply-btn-v2" onClick={() => { onApply(pendingField, pendingDir); setOpen(false); }}>
            Apply sort
          </button>
        </div>,
        document.body
      )}
    </>
  );
};

export default SortDropdown;
